var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#DDF5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 29H15C11 29 10 28 10 24V16C10 12 11 11 15 11H25C29 11 30 12 30 16V24C30 28 29 29 25 29Z",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16H27",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20H27",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24H27",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 19.2899C17.4996 19.2899 18.3099 18.4796 18.3099 17.4799C18.3099 16.4803 17.4996 15.6699 16.4999 15.6699C15.5003 15.6699 14.6899 16.4803 14.6899 17.4799C14.6899 18.4796 15.5003 19.2899 16.4999 19.2899Z",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.33C19.86 22.88 18.71 21.74 17.26 21.61C16.76 21.56 16.25 21.56 15.74 21.61C14.29 21.75 13.14 22.88 13 24.33",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfDiagnosis);
export default __webpack_public_path__ + "static/media/selfDiagnosis.d7adb733ba458b12316d16b8a247008b.svg";
export { ForwardRef as ReactComponent };